export default __webpack_public_path__ + "static/media/srisailamVisitFourteen.7611ee6a.jpg";